<div *ngIf="isVisible" class="popup-overlay">
    <div class="modal-dialog show2" style="margin-left: 500px;">
        <div class="modal-content">
          <div class="modal-body modal-contenido">
            <div _ngcontent-serverapp-c77="" class="logo-calypso-central" style="margin-left: 30%;">
                <img _ngcontent-serverapp-c77="" alt="logo-calypso" src="../../../assets/imgs/calypso-alert.png" class="img" style="height: 200px; width: 200px;">
            </div>
            <br>
            <a (click)="closeModal()" class="modal-close">
              <img src="../../../assets/icons/header/clear.png" alt="Icono de cerrar" class="icon-button icon-img" style="padding-top: 10px;padding-right: 10px;width: 20px;height: 20px;" />
            </a>
            <div class="col-title" style="margin-left: 25%;">
              <p class="title h3 mb-5">📢 Aviso Importante 📢</p>
            </div>
            <h4 class="subtitle">Estimados clientes, <br><br>
                Les informamos que nuestra página estará en mantenimiento desde hoy, 10 de marzo a las 8:00 PM, hasta el 11 de marzo a las 10:00 AM. Durante este período, el servicio no estará disponible.
                <br><br>
                Agradecemos su comprensión y paciencia. Estamos trabajando para mejorar su experiencia.
                <br><br>
                ¡Gracias por su preferencia! 🙌</h4>
          </div>
        </div>
    </div>
</div>